<template>
  <v-container>
    <v-layout row wrap v-if="error">
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <v-alert :value="true">{{ error }}</v-alert>
      </v-flex>
    </v-layout>
    <v-layout v-if="album" row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <static-page-content :slug="slug" />
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="album" align-space-between fill-height>
      <template>
        <v-flex lg6 md6 sm12 xs12 :class="['pa-2']">
          <v-card :class="['full-height']">
            <v-card-text>
              <template>
                <v-layout v-if="album" row wrap>
                    <v-flex :lg6="isPurchaseable" :md6="isPurchaseable" :sm6="isPurchaseable" :class="['pr-1']" v-if="!$config.bandCampPlayer.use">
                      <v-btn small block :color="$config.colors.primary" aria-label="play-album" :title="$lang.playAlbumInNewWindow" @click="playAlbum(album.embedParams[1].album, album.title)">
                        {{ $lang.playAlbumInNewWindow }}
                      </v-btn>
                    </v-flex>
                  <v-flex :lg6="!$config.bandCampPlayer.use" :md6="!$config.bandCampPlayer.use" :sm6="!$config.bandCampPlayer.use" v-if="isPurchaseable" :class="['pl-1']">
                    <buy-album :album="album" />
                  </v-flex>
                </v-layout>
                <album-player v-if="$config.bandCampPlayer.use" :album="$config.albumDetails[slug]" />
                <on-page-vc-audio-player v-else track-action-icon="mdi-chevron-double-right" :album="album.embedParams[1].album" :track-action-icon-hint="$lang.viewTrackInfo" @track-action-icon-click="onTrackActionIconClick"/>
              </template>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex lg6 md6 sm12 xs12 :class="['pa-2']">
          <v-card :class="['full-height']">
            <v-card-text>
              <v-img ripple @click="showImageInLightbox(album.art)" :lazy-src="$config.replacementImage" :src="album.art" :class="['elevation-12', 'clickable']" />
              <p v-html="album.about" :class="['mt-4', 'caption']" />
              <p v-html="album.credits" :class="['caption', 'mb-0', 'first-letter-uppercase']" />
            </v-card-text>
          </v-card>
        </v-flex>
      </template>
      <featured-video />
    </v-layout>
    <news-ticker />
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageMusicAlbum',
  mixins: [
    methods
  ],
  data () {
    return {
      error: null,
      slug: this.$route.params.album,
      album: null
    }
  },
  watch: {
    '$route.params.album' () {
      this.album = null
      this.$nextTick(() => {
        this.getAlbum()
      })
      // this.$nextTick()
      //
    }
  },
  computed: {
    isPurchaseable () {
      return this.getAlbumDetails(this.album.albumSlug).purchasable
      // return Object.keys(this.$config.purchaseableAlbums).includes(this.album.albumSlug)
    }
  },
  mounted () {
    this.getAlbum()
  },
  methods: {
    onTrackActionIconClick ($event) {
      this.$router.push({
        path: `/music/${this.slug}/${$event.slug}`
      })
    },
    playAlbum (album, title) {
      if (this.$config.bandCampPlayer.use) {
        this.$root.$emit('play-album', album)
        this.gtagEvent('player', 'open', title)
      } else {
        this.openVcAudioPlayer(album)
      }
    },
    setAlbum (data) {
      this.album = data
      this.$root.albumIdForTheTrackPage = parseInt(this.album.embedParams[1].album, 10)
    },
    getAlbum () {
      const slug = this.$route.path
      const url = this.getBCRoute('album')
      const cachedData = this.retrieveCachedData('music', slug)
      if (cachedData) {
        return this.setAlbum(cachedData)
      }
      this.$http({
        url,
        method: 'POST',
        data: {
          artist: this.$config.bcArtistSlug,
          album: this.slug
        }
      }).then(response => {
        const code = response.data.code
        if (code === 0) {
          const data = response.data.data
          this.setAlbum(data)
          this.cacheData(slug, 'music', data)
        } else {
          this.error = this.$lang.errors[code]
        }
      }).catch(error => {
        console.error(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/music-album.vue